/* ZEVU — interacciones (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.zv-reveal:not(.zv-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('zv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-zv-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      items.forEach(function (img) {
        var box = img.parentElement.getBoundingClientRect();
        var strength = parseFloat(img.getAttribute('data-zv-parallax')) || 0;
        var progress = (box.top + box.height / 2 - window.innerHeight / 2) / window.innerHeight;
        var t = Math.min(1, Math.max(0, (progress + 1) / 2));
        img.style.setProperty('--zv-parallax', (-t * strength).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    var pdp = (root || document).querySelector('[data-zv-pdp]');
    if (!pdp || pdp.dataset.zvReady) return;
    pdp.dataset.zvReady = '1';

    var dataEl = pdp.querySelector('[data-zv-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = pdp.querySelector('input[name="id"]');
    var addBtn = pdp.querySelector('[data-zv-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-zv-add-label]') : null;
    var priceNow = pdp.querySelectorAll('[data-zv-price]');
    var priceWas = pdp.querySelector('[data-zv-compare]');
    var saveTag = pdp.querySelector('[data-zv-save]');
    var errorBox = pdp.querySelector('[data-zv-error]');
    var labels = { add: pdp.dataset.addLabel, soldout: pdp.dataset.soldoutLabel, unavailable: pdp.dataset.unavailableLabel };
    var moneyFormat = pdp.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var withComma = value.replace('.', ',');
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    /* Galería */
    var mainImg = pdp.querySelector('[data-zv-main]');
    var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-zv-thumb]'));
    var current = 0;
    function show(i) {
      if (!thumbs.length || !mainImg) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      mainImg.classList.add('is-fading');
      var next = new Image();
      next.onload = function () {
        mainImg.src = t.dataset.full;
        mainImg.srcset = t.dataset.srcset || '';
        mainImg.alt = t.dataset.alt || '';
        mainImg.classList.remove('is-fading');
      };
      next.src = t.dataset.full;
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === current); x.setAttribute('aria-current', k === current); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = pdp.querySelector('[data-zv-prev]'), nextBtn = pdp.querySelector('[data-zv-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    function showMediaId(mediaId) {
      if (!mediaId) return;
      thumbs.forEach(function (t, i) { if (t.dataset.mediaId == mediaId) show(i); });
    }

    /* Variantes */
    var fieldsets = Array.prototype.slice.call(pdp.querySelectorAll('[data-zv-option]'));
    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setButton(state) {
      if (!addBtn) return;
      addBtn.disabled = state !== 'add';
      if (addLabel) addLabel.textContent = labels[state];
    }
    function updateAvailabilityMarks() {
      if (fieldsets.length !== 1) return;
      fieldsets[0].querySelectorAll('input').forEach(function (inp) {
        var v = findVariant([inp.value]);
        var lab = inp.nextElementSibling;
        if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function onChange() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var out = fs.querySelector('[data-zv-selected]');
        if (out) out.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      if (!v) { setButton('unavailable'); return; }
      if (idInput) idInput.value = v.id;
      priceNow.forEach(function (el) { el.textContent = formatMoney(v.price); });
      if (priceWas) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.textContent = onSale ? formatMoney(v.compare_at_price) : '';
        priceWas.hidden = !onSale;
        if (saveTag) {
          saveTag.hidden = !onSale;
          if (onSale) saveTag.textContent = saveTag.dataset.template.replace('[amount]', formatMoney(v.compare_at_price - v.price));
        }
      }
      setButton(v.available ? 'add' : 'soldout');
      if (v.featured_media) showMediaId(v.featured_media.id);
      if (window.history && window.history.replaceState && !window.Shopify?.designMode) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
    updateAvailabilityMarks();

    /* Cantidad */
    var qty = pdp.querySelector('[data-zv-qty]');
    if (qty) {
      pdp.querySelectorAll('[data-zv-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.zvQtyStep, 10);
          qty.value = Math.max(1, n);
        });
      });
    }

    /* Añadir al carrito (abre el cajón de Dawn si existe) */
    var form = pdp.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return; /* envío normal → /cart */
        e.preventDefault();
        if (errorBox) errorBox.textContent = '';
        addBtn.classList.add('is-loading');
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { if (errorBox) errorBox.textContent = res.description || res.message; return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    /* Barra fija en móvil */
    var sticky = document.querySelector('[data-zv-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-zv-count]:not([data-zv-counted])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-zv-counted', '1');
      var target = parseFloat(el.getAttribute('data-zv-count')) || 0;
      var decimals = (String(target).split('.')[1] || '').length;
      if (reduceMotion) { el.textContent = target.toLocaleString('en-US', { minimumFractionDigits: decimals }); return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Pestañas (4 en 1) ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-zv-tabs]').forEach(function (wrap) {
      if (wrap.dataset.zvReady) return;
      wrap.dataset.zvReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(i, focus) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
    });
  }

  function initAll(root) { initReveals(root); initProduct(root); initCounters(root); initTabs(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
